export default {"src":"/_next/static/media/logo-3.cf774149.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};